import React from 'react';
import { connect } from 'react-redux';
import {Button,Paper,Divider,CssBaseline,TextField,Checkbox,Grid,Box,Typography,Container
,FormControlLabel,InputLabel,Select,FormHelperText,Hidden} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import {NavLink as RouterLink} from 'react-router-dom';
import { history } from "../../../components/helpers/History";
import {PatientActions} from '../../../redux/actions/PatientActions';

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class PatientAddressInfo extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          userid : props.id,
          submitted: false
      };
      
  }

  render(){
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Patient Address Info</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
        <CssBaseline />
            <Formik enableReinitialize
              initialValues={{
                id:this.props.address.id,
                phyAddress1: this.props.address && this.props.address.phyAddress1?this.props.address.phyAddress1:'',
                phyAddress2: this.props.address && this.props.address.phyAddress2 ? this.props.address.phyAddress2:'' ,
                phyAddress3 : this.props.address && this.props.address.phyAddress3 ? this.props.address.phyAddress3 :'',
                phyCity : this.props.address && this.props.address.phyCity ? this.props.address.phyCity : '',
                phyState : this.props.address && this.props.address.phyState ? this.props.address.phyState : '',
                phyZipCode : this.props.address && this.props.address.phyZipCode ? this.props.address.phyZipCode:'',
                billingAddress1: this.props.address && this.props.address.billingAddress1 ? this.props.address.billingAddress1 : '',
                billingAddress2: this.props.address && this.props.address.billingAddress2 ? this.props.address.billingAddress2 : '',
                billingAddress3 : this.props.address && this.props.address.billingAddress3 ? this.props.address.billingAddress3:'',
                billingCity : this.props.address && this.props.address.billingCity?this.props.address.billingCity:'',
                billingState : this.props.address && this.props.address.billingState?this.props.address.billingState:'',
                billingZipCode : this.props.address && this.props.address.billingZipCode?this.props.address.billingZipCode:'',
                isBillingAddressSameAsPhysicalAddress : this.props.address && this.props.address.isBillingAddressSameAsPhysicalAddress?this.props.address.isBillingAddressSameAsPhysicalAddress:false,
              }}

              validationSchema={Yup.object().shape({
                phyAddress1: Yup.string()
                  .max(200)
                  .required("Address1 is required"),
               phyCity: Yup.string()
                  .max(30)
                  .required("City is required"),
                phyState : Yup.string()
                .required("State is required"),
                phyZipCode : Yup.string()
                .required("Zipcode is required"),
                billingAddress1: Yup.string()
                .max(200)
                .required("Address1 is required"),
                billingCity: Yup.string()
                  .max(30)
                  .required("City is required"),
                billingState : Yup.string()
                .required("State is required"),
                billingZipCode : Yup.string()
                .required("Zipcode is required")
                })
              }
                
              
                onSubmit={(values, { setSubmitting }) => {
                  this.props.updateAddressInfo(values);
                  console.log(values);
                }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit} className={classes.form}
                noValidate
                name="form"> 
                  <Box sx={{ mb: 3 }}>
                    <Typography component="h3" variant="body1">Physical Address</Typography>
                  </Box>
                  <Grid container spacing={1}>
                   <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.phyAddress1 && errors.phyAddress1)}
                          fullWidth
                          helperText={touched.phyAddress1 && errors.phyAddress1}
                          label="Address 1"
                          margin="normal"
                          name="phyAddress1"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.phyAddress1}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField
                          error={Boolean(touched.phyAddress2 && errors.phyAddress2)}
                          fullWidth
                          helperText={touched.phyAddress2 && errors.phyAddress2}
                          label="Address2"
                          margin="normal"
                          name="phyAddress2"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.phyAddress2}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.phyAddress3 && errors.phyAddress3)}
                        fullWidth
                        helperText={touched.phyAddress3 && errors.phyAddress3}
                        label="Address3"
                        margin="normal"
                        name="phyAddress3"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phyAddress3}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.phyCity && errors.phyCity)}
                        fullWidth
                        helperText={touched.phyCity && errors.phyCity}
                        label="City"
                        margin="normal"
                        name="phyCity"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phyCity}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.phyState && errors.phyState)}
                        fullWidth
                        helperText={touched.phyState && errors.phyState}
                        label="State"
                        margin="normal"
                        name="phyState"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phyState}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.phyZipCode && errors.phyZipCode)}
                        fullWidth
                        helperText={touched.phyZipCode && errors.phyZipCode}
                        label="Zip code"
                        margin="normal"
                        name="phyZipCode"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.phyZipCode}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  
                  <Divider variant="middle" className={classes.divider} />
                  <Typography component="h3" variant="body1">Billing Address</Typography>
                  <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={<Checkbox checked={values.isBillingAddressSameAsPhysicalAddress} name="isBillingAddressSameAsPhysicalAddress" 
                      onChange={(e,checked)=>{
                       if(checked){
                          values.billingAddress1 = values.phyAddress1;
                          values.billingAddress2 = values.phyAddress2;
                          values.billingAddress3 = values.phyAddress3;
                          values.billingCity = values.phyCity;
                          values.billingState = values.phyState;
                          values.billingZipCode = values.phyZipCode;
                        }else{
                          values.billingAddress1 = '';
                          values.billingAddress2 = '';
                          values.billingAddress3 = '';
                          values.billingCity = '';
                          values.billingState = '';
                          values.billingZipCode = '';
                        }
                        handleChange(e,checked);
                      }}/>}
                      label="Is billing address same as physical address"
                    />
                  </Grid>
                  
                   <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.billingAddress1 && errors.billingAddress1)}
                          fullWidth
                          helperText={touched.billingAddress1 && errors.billingAddress1}
                          label="Address 1"
                          margin="normal"
                          name="billingAddress1"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.billingAddress1}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField
                          error={Boolean(touched.billingAddress2 && errors.billingAddress2)}
                          fullWidth
                          helperText={touched.billingAddress2 && errors.billingAddress2}
                          label="Address2"
                          margin="normal"
                          name="billingAddress2"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.billingAddress2}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.billingAddress3 && errors.billingAddress3)}
                        fullWidth
                        helperText={touched.billingAddress3 && errors.billingAddress3}
                        label="Address3"
                        margin="normal"
                        name="billingAddress3"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.billingAddress3}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.billingCity && errors.billingCity)}
                        fullWidth
                        helperText={touched.billingCity && errors.billingCity}
                        label="City"
                        margin="normal"
                        name="billingCity"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.billingCity}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.billingState && errors.billingState)}
                        fullWidth
                        helperText={touched.billingState && errors.billingState}
                        label="State"
                        margin="normal"
                        name="billingState"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.billingState}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={Boolean(touched.billingZipCode && errors.billingZipCode)}
                        fullWidth
                        helperText={touched.billingZipCode && errors.billingZipCode}
                        label="Zip code"
                        margin="normal"
                        name="billingZipCode"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.billingZipCode}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <div className={classes.buttons}>
                  <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={()=>{history.goBack();}}
                      >
                          Cancel
                      </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                    >
                      Submit
                    </Button>
                    
                  </div>
                  
                </form>
              )}
            </Formik>
            
        </Container>
      </>
    );
  }
}


function mapStateToProps(state) {
  const  loginUserId  = state.authentication.user.id;
  const profile = state.doctor.profile;
  return { loginUserId , profile};
}

const mapDispatchToProps = (dispatch) => {
  return {
    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles,{ withTheme: true })(PatientAddressInfo));